"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramPanelMeta = exports.ProgramPanelMetaDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var ui_1 = require("@shapeable/ui");
var use_filtered_date_programs_1 = require("../../hooks/use-filtered-date-programs");
var entity_link_value_1 = require("../../components/entities/entity-link-value");
var grid_1 = require("../../components/elements/grid");
var cls = (0, utils_1.classNames)('problem-panel-meta');
exports.ProgramPanelMetaDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    padding-bottom: ", ";\n    font-weight: 500;\n    margin: 0;\n    font-size: ", ";\n  "], ["\n    color: ", ";\n    padding-bottom: ", ";\n    font-weight: 500;\n    margin: 0;\n    font-size: ", ";\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(16))
});
var UpcomingValuesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var CurrentValuesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ProgramStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n    padding-bottom: ", ";\n  "], ["\n    display: block;\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var NoResultsMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled_components_1.default.h2(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  CurrentValues: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), CurrentValuesStyles),
  UpcomingValues: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), UpcomingValuesStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Program: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ProgramStyles),
  NoResultsMessage: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), NoResultsMessageStyles)
};
var ProgramPanelMeta = function (props) {
  var className = props.className,
    children = props.children,
    _a = props.items,
    items = _a === void 0 ? [] : _a;
  var t = (0, ui_1.useLang)();
  var _b = (0, use_filtered_date_programs_1.useFilteredDatePrograms)(items),
    currentPrograms = _b.currentPrograms,
    upcomingPrograms = _b.upcomingPrograms;
  var hasPrograms = !!currentPrograms.length || !!upcomingPrograms.length;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, !hasPrograms && react_1.default.createElement(My.NoResultsMessage, null, t('No Programs Listed')), !!currentPrograms.length && react_1.default.createElement(My.CurrentValues, null, react_1.default.createElement(My.Label, null, t('Current'), ":"), currentPrograms.map(function (program) {
    return react_1.default.createElement(My.Program, {
      key: program.id,
      badge: '',
      variant: 'small',
      entity: program
    });
  })), !!upcomingPrograms.length && react_1.default.createElement(My.UpcomingValues, null, react_1.default.createElement(My.Label, null, t('Upcoming'), ":"), upcomingPrograms.map(function (program) {
    return react_1.default.createElement(My.Program, {
      key: program.id,
      badge: '',
      variant: 'small',
      entity: program
    });
  })));
};
exports.ProgramPanelMeta = ProgramPanelMeta;
exports.ProgramPanelMeta.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;